import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../../context";
import { Container } from "../../../components";
import { Card, CardContent, CardHeader } from "@mui/material";
import { Button } from "react-bootstrap";
import useWindowSize from "../../../hooks/useWindowSize";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

const MenuAdmin = () => {
  const { actions: ua } = useContext(UserContext);
  const size = useWindowSize();
  const { width } = size;

  const nav = useNavigate();

  const permisos = ua.user().permissions;
  const permisosOrigen = permisos.filter((permiso) => permiso.name.startsWith("origen."));

  const menuOptions = [
    {
      title: "Solicitudes",
      description: "Gestiona y administra todas las solicitudes disponibles en el sistema.",
      path: "/admin/actas",
      icon: <FormatListBulletedIcon sx={{ fontSize: 65, color: "#133040" }} />,
    },
    {
      title: "Podadores",
      description: "Administracion y gestión de todo los podadores registrados y sus permisos.",
      path: "/podadores",
      icon: <PersonSearchIcon sx={{ fontSize: 65, color: "#133040" }} />,
    },
    // {
    //   title: "Barrios",
    //   description: "Configura los barrios y sus respectivas zonas de trabajo.",
    //   path: "/barrios",
    // },
    // {
    //   title: "Especies",
    //   description: "Administra las especies de árboles disponibles en el sistema.",
    //   path: "/especies",
    // },
  ];

  return (
    <Container linkBack={"/"} /* titulo={"Panel de admin"} */ size={"md"}>
      {/* <div className="container_Admin p-3 rounded"> */}
      <div className="bg-body p-3 rounded pb-5">
        <section className="d-flex flex-column align-items-center mt-5 ">
          <h2 className="mb-2 pt-3">Panel de Admin</h2>
          <p className="text-center fw-light fs-6 ">
            Desde aquí podés revisar, aprobar o derivar las solicitudes relacionadas con el arbolado
            urbano.
          </p>
        </section>
        <div
          className={` ${
            width >= 640 ? "" : "flex-column"
          } d-flex flex-wrap gap-2 col-8 mx-auto justify-content-center w-100 gap-5`}
        >
          {permisosOrigen.map((permiso) => {
            const nombreOrigen = permiso.name.split(".")[1];
            return (
              <button
                className="btn btn-primary w-100 btn-menu"
                onClick={() => nav(`/certificados/${nombreOrigen}`)}
                hidden={!ua.hasPermission(permiso.name)}
                key={permiso.name}
              >
                {nombreOrigen.toUpperCase()}
              </button>
            );
          })}

          {menuOptions.map((opc) => {
            if (ua.hasRole("admin.app") || ua.hasRole("admin.permisos"))
              return (
                <section key={opc.title} className={`p-3 ${width >= 640 ? "col-4" : "col-12"} `}>
                  <Card
                    key={opc.title}
                    className={`shadow-lg rounded-2xl d-flex flex-column align-items-center p-2 py-3`}
                  >
                    {opc.icon}
                    <h5
                      style={{ color: "#133040", fontSize: "20px" }}
                      className=" font-bold m-0 pt-3 "
                    >
                      {opc.title}
                    </h5>
                    <CardContent className="pt-2">
                      <p className="text-gray-600 text-center" style={{ fontSize: "16px" }}>
                        {opc.description}
                      </p>

                      <Button
                        size="md"
                        style={{ background: "#127AE2", color: "#127AE2" }}
                        className="mt-3 w-100 btn "
                        onClick={() => nav(opc.path)}
                      >
                        Ir a {opc.title}
                      </Button>
                    </CardContent>
                  </Card>
                </section>
                // <Card
                //   key={opc.title}
                //   className={`shadow-lg rounded-2xl ${width >= 640 ? "col-5" : "col-12"} `}
                // >
                //   <h5 className="text-xl font-bold m-0 pt-3 ps-3">{opc.title}</h5>
                //   <CardContent>
                //     <p className="text-gray-600">{opc.description}</p>
                //     <hr className="m-0" />
                //     <Button className="mt-3 w-full btn btn-sm" onClick={() => nav(opc.path)}>
                //       Ir a {opc.title}
                //     </Button>
                //   </CardContent>
                // </Card>
              );
          })}

          {/* {ua.hasRole("admin.app") && (
                        <article className=" ">
                            <h4>Actas</h4>
                            <p></p>
                            <Link className="btn btn-primary w-100 btn-menu" to={"/admin/actas"}>
                                Actas
                            </Link>
                        </article>
                    )}
                    {ua.hasRole("admin.app") && (
                        <Link className="btn btn-primary w-100 btn-menu" to={"/podadores"}>
                            Podadores
                        </Link>
                    )}
                    {ua.hasRole("admin.app") && (
                        <Link className="btn btn-primary w-100 btn-menu" to={"/barrios"}>
                            Barrios
                        </Link>
                    )}
                    {ua.hasRole("admin.app") && (
                        <Link className="btn btn-primary w-100 btn-menu" to={"/especies"}>
                            Especies
                        </Link>
                    )} */}
        </div>
      </div>
      {/* </div> */}
    </Container>
  );
};

export default MenuAdmin;
